import React from 'react'
import { Container, ContainerInterno, BoxCol6, ImagemPrincipal, TextoBanner, LegendaBanner, BoxTag, BoxTagTexto, BoxAssinaturas, ItemAssinatura, ItemAssinaturaTagRelampago, ItemAssinaturaTagRelampagoImg, ItemAssinaturaTagRelampagoTextos, ItemAssinaturaTagRelampagoTextosTitulo, ItemAssinaturaTagRelampagoTextosLegenda, ItemAssinaturaTitulo, ListaBonus, ListaBonusItem, ItemAssinaturaPrecoDe, ItemAssinaturaPrecoPor, ItemAssinaturaLinkCartao, ItemAssinaturaLinkAVista } from './Styled'
import logoTJSP from 'images/promocao-janeiro-2026/nao-seja-mais-demitido.png'
import bgBannerDesktop from 'images/promocao-janeiro-2026/bg-nao-seja-mais-demitido.jpg'
import bgBannerMobile from 'images/promocao-janeiro-2026/bg-nao-seja-mais-demitido-mobile.jpg'
import icRelampago from 'images/promocao-janeiro-2026/ic-relampago.png'
import { replace } from 'lodash'

export default function BannerPrincipal ({ planos, lote }) {

	const tituloLote = (lote) => {
		switch (lote) {
			case 1:
				return "LOTE RELÂMPAGO"
			case 2:
				return "LOTE ESPECIAL"
			case 3:
				return "LOTE 1"
			case 4:
				return "ÚLTIMO LOTE"
			default:
				return ""
		}
	}

	const textoTag = (lote) => {
		switch (lote) {
			case 1:
				return "Somente hoje!"
			case 2:
				return "Melhor oferta (somente até 19/01)"
			case 3:
				return "Melhor oferta (somente até 26/01)"
			case 4:
				return "Melhor oferta (somente até 02/02)"
			default:
				return ""
		}
	}

	return (
		<Container bgDesktop={bgBannerDesktop} bgMobile={bgBannerMobile} id='bannerPromocao'>
			<ContainerInterno>

				{/* Textos Banner */}
				<BoxCol6 className='boxTextos'>
					<ImagemPrincipal src={logoTJSP} />
					<TextoBanner>Estude com o material utilizado por <strong>7 a cada 10<br /> aprovados</strong> em concursos no país!</TextoBanner>
					<LegendaBanner>353 editais e 73.534 vagas previstas para 2026</LegendaBanner>
				</BoxCol6>

				{/* Aviso Banner */}
				<BoxCol6>
					
					{/* Box Economize */}
					<BoxTag>
						<BoxTagTexto>{textoTag(lote)}</BoxTagTexto>
					</BoxTag>

					{/* Lista Assinaturas */}
					<BoxAssinaturas>

						{ planos.map((assinatura, indexAssinaturas) => {
							return assinatura.assinaturas.map((item, index) => {

								return (
									<React.Fragment>
										{ index > 0 ? <ItemAssinatura key={index}>

											{/* Tag Relâmpago */}
											<ItemAssinaturaTagRelampago primeiro={indexAssinaturas === 0 ? true : false}>
												{ lote === 1 ? <ItemAssinaturaTagRelampagoImg src={icRelampago} /> : null }
												<ItemAssinaturaTagRelampagoTextos>
													<ItemAssinaturaTagRelampagoTextosTitulo>{ tituloLote(lote) }</ItemAssinaturaTagRelampagoTextosTitulo>
													<ItemAssinaturaTagRelampagoTextosLegenda>{ indexAssinaturas === 0 ? 'MAIS VENDIDO' : 'MAIOR DESCONTO' }</ItemAssinaturaTagRelampagoTextosLegenda>
												</ItemAssinaturaTagRelampagoTextos>
												{ lote === 1 ? <ItemAssinaturaTagRelampagoImg src={icRelampago} /> : null }
											</ItemAssinaturaTagRelampago>

											{/* Título */}
											<ItemAssinaturaTitulo>{replace(item.nome.split(" - ")[0], "Assinatura ", "")}</ItemAssinaturaTitulo>

											{/* Lista Bônus */}
											<ListaBonus>
												{ item.cartao.bonus && item.cartao.bonus > 0 ? <ListaBonusItem>+ { item.cartao.bonus } { item.cartao.bonus > 1 ? 'meses' : 'mês' } grátis</ListaBonusItem> : null }
												{ item.cartao.mentoria && item.cartao.mentoria > 0 ? <ListaBonusItem>+ { item.cartao.mentoria } { item.cartao.mentoria > 1 ? 'meses' : 'mês' } de coaching</ListaBonusItem> : null }
											</ListaBonus>
											
											{/* Preço De */}
											<ItemAssinaturaPrecoDe>{item.cartao.preco_de} por</ItemAssinaturaPrecoDe>

											{/* Preço Por */}
											<ItemAssinaturaPrecoPor>12x <strong>{item.cartao.preco_por.split('12x ')[1]}</strong></ItemAssinaturaPrecoPor>

											{/* Link Cartão */}
											<ItemAssinaturaLinkCartao primeiro={ indexAssinaturas == 0 ? true : false } href={item.cartao.link}>Parcele em 12x sem juros</ItemAssinaturaLinkCartao>

											{/* Link A Vista */}
											<ItemAssinaturaLinkAVista primeiro={ indexAssinaturas == 0 ? true : false } href={item.boleto.link}>Ganhe +10% OFF à vista</ItemAssinaturaLinkAVista>

										</ItemAssinatura>
											
										: null }
									</React.Fragment>
								)

							})
						})}

					</BoxAssinaturas>

				</BoxCol6>

			</ContainerInterno>
		</Container>
	)
}
